// @flow

import * as React from 'react';

import OutsideClickable from '@zapier/common-components/src/components/OutsideClickable';
import Timeout from '@zapier/common-components/src/components/Timeout';
import { Duration } from '@zapier/theme';

type Props = {
  /** Children function that accepts isConfirming and onClick */
  children: ({ isConfirming: boolean, onClick: () => void }) => React.Node,
  /** True to start confirming without user interaction */
  isConfirming?: boolean,
  /** Called when is accepted */
  onConfirm: () => void,
  /** false to never time out confirmation */
  shouldTimeOut?: boolean,
};

const Confirmation = (props: Props) => {
  const [isConfirming, setIsConfirming] = React.useState(
    props.isConfirming || false
  );

  const onCancel = () => setIsConfirming(false);

  const inner = props.children({
    isConfirming,
    onClick: () => {
      setIsConfirming(!isConfirming);
      if (isConfirming) {
        props.onConfirm();
      }
    },
  });

  return isConfirming ? (
    <Timeout
      delay={Duration.confirmationTimeout}
      isWaiting={props.shouldTimeOut}
      onTimeout={onCancel}
    >
      <OutsideClickable onClickOutside={onCancel}>{inner}</OutsideClickable>
    </Timeout>
  ) : (
    inner
  );
};

Confirmation.defaultProps = {
  isConfirming: false,
  shouldTimeOut: true,
};

export default Confirmation;
